import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { message } from 'antd'
import SaveButton from '../../../components/Shared/SaveButton'
import BorderlessInput from '../../../components/Shared/BorderlessInput'
import BackLink from '../../../components/Shared/BackLink'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

import './index.scss'

class ChangePassword extends React.Component {

  constructor(props) {
    super()
    const { user } = props
    this.state = {
      loading: false,
      errors: {
        new_password: null,
        new_password_confirmation: null
      },
      form: {
        old_password: '',
        new_password: '',
        new_password_confirmation: ''
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillReceiveProps() {
    const { history } = this.props
    this.setState({ loading: false })
    history.push('/profile')
  }

  handleChange({ target }) {
    const passwordRegExp = /^(?=.*[a-zA-Z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/
    const { form, errors } = this.state

    switch (target.name) {
      case 'new_password':
        /*errors.new_password = !passwordRegExp.test(form.new_password)
          ? 'Password needs to be at least 8 characters, a lowercase letter, an uppercase letter and a number.'
          : null*/
        break;
      case 'new_password_confirmation':
        errors.new_password_confirmation = form.new_password !== target.value
          ? 'Confirmation don\'t match password, please try again.'
          : null
        break;
    }

    this.setState({
      errors,
      form: {
        ...form,
        [target.name]: target.value
      }
    })
  }

  handleSubmit(e) {
    e.preventDefault()
    let $this = this
    const {form:{old_password, new_password}, errors } = this.state
    const {history} = this.props
    if (errors.new_password || errors.new_password_confirmation) {
      return null
    }

    this.setState({loading:true})

    CloudFlyerAPI
      .user_account
      .changePassword({old_password, new_password})
      .then(()=>{
        message.success('Password changed successfully.')
        history.push('/profile')
        $this.setState({loading:false})
      })
      .catch(err=>{
        $this.setState({loading:false})
        console.error(err)
        message.error(((err.response||{}).data||{}).message)
      })
  }

  render() {
    const { form, loading, errors } = this.state
    return (
      <div className='change-password-container'>
        <BackLink to='/profile' />
        <div className='change-password'>
          <h3>Change Your Password</h3>
          <form method='post' onSubmit={this.handleSubmit}>
            <BorderlessInput type='password' required
              value={form.old_password} name='old_password'
              onChange={this.handleChange} label='Old Password' />
            <BorderlessInput type='password' required error={errors.new_password}
              value={form.new_password} name='new_password'
              onChange={this.handleChange} label='New Password' />
            <BorderlessInput type='password' required error={errors.new_password_confirmation}
              value={form.new_password_confirmation} name='new_password_confirmation'
              onChange={this.handleChange} label='Confirm your new password' />
            <div className='save-button-container'>
              <SaveButton type='submit'>
                {loading ? 'Saving...' : 'Change Password'}
              </SaveButton>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth }) => ({ user: auth.user })

export default withRouter(connect(mapStateToProps)(ChangePassword))
